export const REMOVE_ROLE_MODAL_PATH = "remove/:shoppableQualificationId";
export const ROLE_REMOVED_MODAL_PATH = "removed/:qualificationId";
export const REMOVE_LICENSE_MODAL_PATH = "license-remove/:licenseId";
export const LICENSE_REMOVED_MODAL_PATH = "license-removed/:licenseId";
export const RENEW_LICENSE_MODAL_PATH = "renew/:licenseId";
